import { MessageSchema } from "@redotech/redo-model/agents/llm-messages";
import { PendingUpdateSchema } from "@redotech/redo-model/agents/platform-agents/settings/pending-update";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const CustomerPortalBuilderThreadSchema = z.object({
  threadId: zExt.objectId(),
  newMessages: z.array(MessageSchema),
  pendingUpdates: z.array(PendingUpdateSchema).optional(),
});

export const messageCustomerPortalBuilder = {
  name: "messageCustomerPortalBuilder" as const,
  input: z.object({
    messages: z.array(MessageSchema),
    threadId: z
      .string()
      .optional()
      .describe("If left undefined, a new thread will be created."),
  }),
  output: z.object({ thread: CustomerPortalBuilderThreadSchema }),
};
